import { render, staticRenderFns } from "./CommentTag.vue?vue&type=template&id=f9acf572&"
import script from "./CommentTag.vue?vue&type=script&lang=js&"
export * from "./CommentTag.vue?vue&type=script&lang=js&"
import style0 from "./CommentTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/html/insights/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VChip,VIcon})
